import { gql } from '@apollo/client';

export const GET_SUBSIDY_REQUESTS = gql`
  query GetSubsidyRequests($creditSubmissionId: ID!, $financeProgramId: ID!) {
    subsidyRequests(creditSubmissionId: $creditSubmissionId, financeProgramId: $financeProgramId) {
      subsidyRequestId
      oem
      customer
      dealer
      lender
      term
      financeAmount
      subsidyPercentage
      dnetPercentage
      dnet
      approvedSubsidyAmount
      equipment {
        id
        year
        make
        model
        serialNumberVin
      }
    }
  }
`;
